<section>
  <header>
    <h1 auto="planning-step2-title">Planning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Identify Outcomes and Key Measures</strong></p>
      <p>
        As you engage in continuous improvement planning, you will want to indicate the Intended Outcomes and Key Measures that will determine the success of each Critical Initiative. The Intended Outcomes guide the institution toward the results it expects while the Key Measures are indicators that track progress toward the Critical Initiatives. Once this step is complete for each Critical Initiative, you will have the necessary elements for the development of your institution’s Strategy Map.
      </p>
    </div>
    <div class="explanation-margin">
      <div class="download-guide-container">
        <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
        <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>identifying Key Measures and the importance of your institution's Strategy Map</strong>.
      </div>
    </div>
  </div>

  <ng-container>
    <ul *ngIf="planHasPriorities && planHasInitiatives">
      <li *ngFor="let priority of objectivePriorities">
        <h2 [style.background-color]="priority.colorCode">{{priority.title}}</h2>
        <ng-container *ngFor="let objective of priority.objectives"> <!--objective loop -->
          <ng-container *ngIf="objective.initiatives.length > 0">
            <div class="objective-header" [style.border-left-color]="priority.colorCode"><!-- objective row  -->
              <!-- text cell -->
              <div class="objective-text">
                <h4>Objective</h4>
                <div>{{ objective.text }}</div>
              </div>
            </div><!-- end of objectives row -->
            <ng-container *ngFor="let initiative of objective.initiatives; let i = index;">
              <div class="initiatives-row"><!-- initiatives row -->
                <!-- color cell -->
                <div class="initiatives-color-cell"></div>
                <!-- text cell -->
                <div class="initiatives-text" [ngClass]="{initiativesNotFirst: i !== 0}">
                  <h4>Critical Initiative</h4>
                  <div class="hard-break-text">{{initiative.description}}</div>
                </div>
              </div><!-- end of initiatives header row -->

              <div class="detail-tables">
                <div class="dual-tables-container">
                  <div class="outcomes-container">
                    <p-table [value]="initiative.outcomes" auto="outcome-table" styleClass="keymeasures-table">
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td [colSpan]="outcomesMeasuresColWidth" class="ui-table-empty-message cg-empty-detail-table-row">
                            <h6>No Intended Outcomes Found</h6>
                            <p>When you create new items, they will be listed here.</p>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Intended Outcome(s)</th>
                          <th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" width="100">
                            <div class="key-measures-header-button">
                              <button auto="add-outcomes-btn" class="btn" (click)="onClickAddOutcomes(initiative)"
                                      [disabled]="isAddOutcomesDisabled(initiative)">
                                Add Intended Outcome
                              </button>
                            </div>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-outcome>
                        <tr>
                          <td class="break-text">
                            {{outcome.outcome}}
                          </td>
                          <td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">
                            <button auto="edit-outcomes-btn" class="fa fa-pencil pointer" pTooltip="Edit Item"
                                    tooltipStyleClass="strategies-tooltip"
                                    (click)="onClickEditOutcome(initiative, outcome)"
                                    *ngIf="!isEditItemDisabled">
                            </button>
                            <button auto="delete-outcomes-btn" class="fa fa-trash pointer" pTooltip="Delete Item"
                                    tooltipStyleClass="strategies-tooltip"
                                    (click)="onClickDeleteOutcome(outcome)"
                                    *ngIf="!isDeleteItemDisabled">
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div auto="key-measures-table" class="keymeasures-container">
                    <p-table [value]="initiative.keyMeasures" styleClass="keymeasures-table">
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td [colSpan]="outcomesMeasuresColWidth" class="ui-table-empty-message cg-empty-detail-table-row">
                            <h6>No Key Measures Found</h6>
                            <p>When you create new items, they will be listed here.</p>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Key Measure(s)</th>
                          <th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" width="100">
                            <div class="key-measures-header-button">
                              <button auto="add-keymeasures-btn" class="btn" (click)="onClickAddKeyMeasures(initiative)"
                                      [disabled]="isAddKeyMeasuresDisabled(initiative)">
                                Add Key Measure
                              </button>
                            </div>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-keyMeasure>
                        <tr>
                          <td class="break-text">{{keyMeasure.measure}}</td>
                          <td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">
                            <button auto="edit-keymeasures-btn" class="fa fa-pencil pointer" pTooltip="Edit Item"
                                    tooltipStyleClass="strategies-tooltip"
                                    (click)="onClickEditKeyMeasure(initiative, keyMeasure)"
                                    *ngIf="!isEditItemDisabled">
                            </button>
                            <button auto="delete-keymeasures-btn" class="fa fa-trash pointer" pTooltip="Delete Item"
                                    tooltipStyleClass="strategies-tooltip"
                                    (click)="onClickDeleteKeyMeasure(initiative, keyMeasure)"
                                    *ngIf="!isDeleteItemDisabled">
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <!--<div class="assumptions-container keymeasures-container">-->
                    <!--<p-table [value]="initiative.assumptions || []" auto="assumptions-table" styleClass="keymeasures-table">-->
                      <!--<ng-template pTemplate="emptymessage">-->
                        <!--<tr>-->
                          <!--<td [colSpan]="outcomesMeasuresColWidth" class="ui-table-empty-message cg-empty-detail-table-row">-->
                            <!--<h6>No Assumptions Found</h6>-->
                            <!--<p>When you create new items, they will be listed here.</p>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="header">-->
                        <!--<tr>-->
                          <!--<th>Assumption(s)</th>-->
                          <!--<th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" width="100">-->
                            <!--<div class="key-measures-header-button">-->
                              <!--<button auto="add-asssumption-btn" class="btn" (click)="onClickAddAssumption(initiative)"-->
                                      <!--[disabled]="isAddAssumptionDisabled(initiative)">-->
                                <!--Add Assumption-->
                              <!--</button>-->
                            <!--</div>-->
                          <!--</th>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="body" let-assumption>-->
                        <!--<tr>-->
                          <!--<td class="break-text">{{assumption.assumptionText}}</td>-->
                          <!--<td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">-->
                            <!--<button auto="edit-assumption-btn" class="fa fa-pencil pointer" pTooltip="Edit Assumption"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickEditAssumption(initiative, assumption)"-->
                                    <!--*ngIf="!isEditItemDisabled">-->
                            <!--</button>-->
                            <!--<button auto="delete-assumption-btn" class="fa fa-trash pointer" pTooltip="Delete Assumption"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickDeleteAssumption(initiative, assumption)"-->
                                    <!--*ngIf="!isDeleteItemDisabled">-->
                            <!--</button>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                    <!--</p-table>-->
                  <!--</div>-->

                </div><!-- end of dual tables container -->
                <!--<div class="dual-tables-container">-->
                  <!-- Influental Factors & Assumptions -->
                  <!--<div class="influental-factors-container outcomes-container">-->
                    <!--<p-table [value]="initiative.influentialFactors || []" auto="influental-factors-table" styleClass="keymeasures-table">-->
                      <!--<ng-template pTemplate="emptymessage">-->
                        <!--<tr>-->
                          <!--<td [colSpan]="outcomesMeasuresColWidth" class="ui-table-empty-message cg-empty-detail-table-row">-->
                            <!--<h6>No Influential Factors Found</h6>-->
                            <!--<p>When you create new items, they will be listed here.</p>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="header">-->
                        <!--<tr>-->
                          <!--<th>Influential Factor(s)</th>-->
                          <!--<th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" width="100">-->
                            <!--<div class="key-measures-header-button">-->
                              <!--<button auto="add-influential-factor-btn" class="btn" (click)="onClickAddInfluentialFactor(initiative)"-->
                                      <!--[disabled]="isAddInfluentialFactorDisabled(initiative)">-->
                                <!--Add Influential Factor-->
                              <!--</button>-->
                            <!--</div>-->
                          <!--</th>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="body" let-influentialFactor>-->
                        <!--<tr>-->
                          <!--<td class="break-text">-->
                            <!--{{'REPLACE ME with influentialFactor.prop'}}-->
                          <!--</td>-->
                          <!--<td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">-->
                            <!--<button auto="edit-influential-factor-btn" class="fa fa-pencil pointer" pTooltip="Edit Influential Factor"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickEditInfluentialFactor(initiative, influentialFactor)"-->
                                    <!--*ngIf="!isEditItemDisabled">-->
                            <!--</button>-->
                            <!--<button auto="delete-influential-factor-btn" class="fa fa-trash pointer" pTooltip="Delete Influential Factor"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickDeleteInfluentialFactor(influentialFactor)"-->
                                    <!--*ngIf="!isDeleteItemDisabled">-->
                            <!--</button>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                    <!--</p-table>-->
                  <!--</div>-->
                  <!--<div auto="key-measures-table" class="keymeasures-container">-->
                    <!--<p-table [value]="initiative.keyMeasures" styleClass="keymeasures-table">-->
                      <!--<ng-template pTemplate="emptymessage">-->
                        <!--<tr>-->
                          <!--<td [colSpan]="outcomesMeasuresColWidth" class="ui-table-empty-message cg-empty-detail-table-row">-->
                            <!--<h6>No Key Measures Found</h6>-->
                            <!--<p>When you create new items, they will be listed here.</p>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="header">-->
                        <!--<tr>-->
                          <!--<th>Key Measure(s)</th>-->
                          <!--<th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled" width="100">-->
                            <!--<div class="key-measures-header-button">-->
                              <!--<button auto="add-keymeasures-btn" class="btn" (click)="onClickAddKeyMeasures(initiative)"-->
                                      <!--[disabled]="isAddKeyMeasuresDisabled(initiative)">-->
                                <!--Add Key Measure-->
                              <!--</button>-->
                            <!--</div>-->
                          <!--</th>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                      <!--<ng-template pTemplate="body" let-keyMeasure>-->
                        <!--<tr>-->
                          <!--<td class="break-text">{{keyMeasure.measure}}</td>-->
                          <!--<td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">-->
                            <!--<button auto="edit-keymeasures-btn" class="fa fa-pencil pointer" pTooltip="Edit Item"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickEditKeyMeasure(initiative, keyMeasure)"-->
                                    <!--*ngIf="!isEditItemDisabled">-->
                            <!--</button>-->
                            <!--<button auto="delete-keymeasures-btn" class="fa fa-trash pointer" pTooltip="Delete Item"-->
                                    <!--tooltipStyleClass="strategies-tooltip"-->
                                    <!--(click)="onClickDeleteKeyMeasure(initiative, keyMeasure)"-->                    <!--*ngIf="!isDeleteItemDisabled">-->
                            <!--</button>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</ng-template>-->
                    <!--</p-table>-->
                  <!--</div>-->
                <!--</div>-->
              </div>


            </ng-container><!-- end of critical initiatives loop -->
          </ng-container>
        </ng-container> <!-- end of objectives loop -->
      </li>
    </ul>
    <ng-container *ngIf="!planHasPriorities && !(isLoading$ | async)">
      <div class="empty-message">
        <h1>
          <span class="text">To begin this subphase, complete the Envisioning phase first.</span>
        </h1>
      </div>
    </ng-container>
    <ng-container *ngIf="planHasPriorities && !planHasInitiatives && !(isLoading$ | async)">
      <div class="empty-message">
        <h1>
          <span class="text">In order to begin this subphase, complete the work in your previous subphases.</span>
        </h1>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="loading-panel">
      <div class='loading-spinner'>
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>
  </ng-template>
</section>

<!-- Dialogs -->
<p-dialog #confirmDeleteDialog
          styleClass="strategies-confirm-dialog"
          [modal]="true"
          [closable]="false"
          appendTo="body"
>
  <p-header>
    <img src="assets/images/exclamation.svg" alt="Alert">
    <span class="dialog-title">Delete {{itemLabel}}</span>
  </p-header>
  <div>Deleting this will also impact any associated content.</div>
  <div><strong>Are you sure?</strong></div>
  <p-footer>
    <button auto="planning-outcome-km-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
            (click)="confirmDeleteDialog.visible = false">
    </button>
    <button auto="planning-outcome-km-delete-btn" class="btn" type="button" pButton label="Delete"
            (click)="onConfirmDeleteDialogAccept()"></button>
  </p-footer>
</p-dialog>

<p-dialog #comfirmDeleteKeyMeasureDialog
          styleClass="delete-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [visible]="keyMeasureDeleteActive"
          appendTo="body">
  <p-header class="delete-modal-header">
    <img src="assets/images/exclamation-white.svg" alt="Alert">
    <span class="dialog-title">Delete Key Measure</span>
  </p-header>
  <div><strong>Are you sure you want to delete this information? Deleting this Key Measure will impact all associated content.</strong></div>
  <div>You are about to delete the following Key Measure:</div>
  <div><strong><i>{{keyMeasureToDelete ? keyMeasureToDelete.measure : ''}}</i></strong></div>
  <div>Once this information is deleted, it can not be undone.</div>

  <p-footer>
    <button auto="cancel-btn" class="btn btn-alt cancel" type="button" pButton label="Cancel"
            (click)="keyMeasureDeleteActive = false">
    </button>
    <button auto="delete-btn" class="btn delete" type="button" pButton label="Delete"
            (click)="onKeyMeasureDelete()"></button>
  </p-footer>
</p-dialog>

<p-dialog #comfirmDeleteReusedKeyMeasureDialog
          styleClass="delete-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [visible]="reusedKeyMeasureDeleteActive"
          appendTo="body">
  <p-header class="delete-modal-header">
    <img src="assets/images/exclamation-white.svg" alt="Alert">
    <span class="dialog-title">Delete Key Measure</span>
  </p-header>
  <div><strong>Are you sure you want to delete this information?</strong></div>
  <div>You are about to delete the following Key Measure:</div>
  <div><strong><i>{{keyMeasureToDelete ? keyMeasureToDelete.measure : ''}}</i></strong></div>

  <div class="radio-container">
    <p-radioButton name="keyMeasureDeleteMethod"
                   label="Delete Key Measure from this initiative only."
                   value="single"
                   id="keyMeasureDeleteSingle"
                   [(ngModel)]="keyMeasureDeleteMethod"></p-radioButton>
  </div>
  <div class="radio-container">
    <p-radioButton name="keyMeasureDeleteMethod"
                   label="Delete Key Measure from all associated initiatives."
                   value="cascade"
                   id="keyMeasureDeleteCascade"
                   [(ngModel)]="keyMeasureDeleteMethod"></p-radioButton>
  </div>
  <div>Once this information is deleted, it can not be undone.</div>

  <p-footer>
    <button auto="cancel-btn" class="btn btn-alt cancel" type="button" pButton label="Cancel"
            (click)="reusedKeyMeasureDeleteActive = false">
    </button>
    <button auto="delete-btn" class="btn delete" type="button" pButton label="Delete"
            (click)="onReusedKeyMeasureDelete()"></button>
  </p-footer>
</p-dialog>

<p-dialog #comfirmDeleteOutcomeDialog
          styleClass="delete-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [visible]="outcomeDeleteActive"
          appendTo="body">
  <p-header class="delete-modal-header">
    <img src="assets/images/exclamation-white.svg" alt="Alert">
    <span class="dialog-title">Delete Outcome</span>
  </p-header>
  <div><strong>Are you sure you want to delete this information? Deleting this Outcome will impact all associated content.</strong></div>
  <div>You are about to delete the following Outcome:</div>
  <div><strong><i>{{outcomeToDelete ? outcomeToDelete.outcome : ''}}</i></strong></div>
  <div>Once this information is deleted, it can not be undone.</div>

  <p-footer>
    <button auto="cancel-btn" class="btn btn-alt cancel" type="button" pButton label="Cancel"
            (click)="outcomeDeleteActive = false">
    </button>
    <button auto="delete-btn" class="btn delete" type="button" pButton label="Delete"
            (click)="onOutcomeDelete()"></button>
  </p-footer>
</p-dialog>

<p-dialog #comfirmEditKeyMeasureDialog
          styleClass="delete-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [visible]="confirmEditKMActive"
          appendTo="body">
  <p-header class="delete-modal-header">
    <img src="assets/images/exclamation-white.svg" alt="Alert">
    <span class="dialog-title">Edit Key Measure</span>
  </p-header>
  <div><strong>Are you sure you want to edit this Key Measure?</strong></div>
  <div>Editing this Key Measure will impact all associated content.</div>
  <p-footer>
    <button auto="cancel-btn" class="btn btn-alt cancel" type="button" pButton label="Cancel"
            (click)="confirmEditKMActive = false">
    </button>
    <button auto="delete-btn" class="btn delete" type="button" pButton label="Confirm"
            (click)="onConfirmEditKM()"></button>
  </p-footer>
</p-dialog>

<!--<p-dialog #confirmDeleteAssumptionDialog-->
          <!--styleClass="delete-modal"-->
          <!--[modal]="true"-->
          <!--[closable]="false"-->
          <!--[draggable]="false"-->
          <!--[visible]="assumptionDeleteActive"-->
          <!--appendTo="body">-->
  <!--<p-header>-->
    <!--<img src="assets/images/exclamation-white.svg" alt="Alert">-->
    <!--<span class="dialog-title">Delete Assumption</span>-->
  <!--</p-header>-->
  <!--<div><strong>Are you sure you want to delete this Assumption? Deleting this will impact all associated content.</strong></div>-->
  <!--<div>You are about to delete the following Assumption:</div>-->
  <!--<div class="hard-break-text"><strong><i>{{assumptionToDelete ? assumptionToDelete.assumptionText : ''}}</i></strong></div>-->
  <!--<div>Once the information is deleted, it can not be undone.</div>-->
  <!--<p-footer>-->
    <!--<button auto="planning-outcome-km-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"-->
            <!--(click)="assumptionDeleteActive = false">-->
    <!--</button>-->
    <!--<button auto="planning-outcome-km-delete-btn" class="btn" type="button" pButton label="Delete"-->
            <!--(click)="onConfirmDeleteAssumption()"></button>-->
  <!--</p-footer>-->
<!--</p-dialog>-->
<!-- Flyouts -->

<p-sidebar #outcomeSidebar
           [(visible)]="isOutcomeActive"
           appendTo="body"
           position="right"
           styleClass="priorities-sidebar"
           (onShow)="outcomeComp.onShowSidebar(outcomeSidebar)"
           (onHide)="outcomeComp.onHideSidebar()">
  <app-outcome #outcomeComp
               (create)="onOutcomeCreate($event)"
               (createError)="onItemError($event)"
               (edit)="onOutcomeEdit($event)"
               (editError)="onItemError($event)"
               (cancel)="isOutcomeActive = false">
  </app-outcome>
</p-sidebar>

<p-sidebar #keyMeasureSidebar
           [(visible)]="isKeyMeasureActive"
           appendTo="body"
           position="right"
           styleClass="priorities-sidebar"
           (onShow)="keyMeasureComp.onShowSidebar(keyMeasureSidebar)"
           (onHide)="keyMeasureComp.onHideSidebar()">
  <app-key-measure #keyMeasureComp
                   [strategyId]="strategyId"
                   [hasKeyMeasures]="hasKeyMeasures"
                   (create)="onKeyMeasuresCreate($event)"
                   (createError)="onItemError($event)"
                   (edit)="onKeyMeasureEdit($event)"
                   (editError)="onItemError($event)"
                   (cancel)="isKeyMeasureActive = false">
  </app-key-measure>
</p-sidebar>

<!--<p-sidebar #assumptionSidebar-->
  <!--[(visible)]="isAssumptionFlyoutActive"-->
           <!--appendTo="body"-->
           <!--position="right"-->
           <!--styleClass="priorities-sidebar"-->
           <!--(onShow)="assumptionFlyout.onShowSidebar(assumptionSidebar)"-->
           <!--(onHide)="assumptionFlyout.onHideSidebar()">-->
  <!--<app-assumption-flyout #assumptionFlyoutComp-->
                         <!--[strategyId]="strategyId"-->
                         <!--[hasAssumptions]="hasAssumptions"-->
                         <!--(create)="onAssumptionsCreate($event)"-->
                         <!--(createError)="onItemError($event)"-->
                         <!--(edit)="onAssumptionEdit($event)"-->
                         <!--(editError)="onItemError($event)"-->
                         <!--(cancel)="isAssumptionFlyoutActive = false"-->
  <!--&gt;-->
  <!--</app-assumption-flyout>-->
<!--</p-sidebar>-->

<!--<p-sidebar #influentialFactorSidebar-->
           <!--[(visible)]="isInfluentialFactorFlyoutActive"-->
           <!--appendTo="body"-->
           <!--position="right"-->
           <!--styleClass="priorities-sidebar"-->
           <!--(onShow)="influentialFactorFlyout.onShowSidebar(influentialFactorSidebar)"-->
           <!--(onHide)="influentialFactorFlyout.onHideSidebar()">-->
  <!--<app-influential-factor-flyout #influentialFactorFlyoutComp-->
                         <!--[strategyId]="strategyId"-->
                         <!--[hasRecords]="hasInfluentialFactors"-->
                         <!--(create)="onInfluentialFactorCreate($event)"-->
                         <!--(createError)="onItemError($event)"-->
                         <!--(edit)="onInfluentialFactorEdit($event)"-->
                         <!--(editError)="onItemError($event)"-->
                         <!--(cancel)="isInfluentialFactorFlyoutActive = false"-->
  <!--&gt;-->
  <!--</app-influential-factor-flyout>-->
<!--</p-sidebar>-->
